var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CardHolder Standard2",class:_vm.classList,attrs:{"title":_vm.desc},on:{"click":_vm.clicked}},[_c('img',{staticClass:"Card",attrs:{"src":require('@/assets/standard2/' + _vm.baseKey + _vm.ext)}})])}
var staticRenderFns = []

export { render, staticRenderFns }